import loadable from '@loadable/component';

export const TomsguideSiteWrapper = loadable(
  () => import(/* webpackChunkName: "tomsguide-site" */ './TomsguideSiteWrapper'),
);
